import { ToastOptions } from "react-toastify";

export const avatarImageSize = { width: 128, height: 128 };

export const toastOptions: ToastOptions = {
  position: "bottom-right",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export const NONE_OPTION = "00000000-0000-0000-0000-000000000000";
export const NOT_NONE_OPTION = "00000000-0000-0000-0000-000000000001";
export const OWN_OPTION = "00000000-0000-0000-0000-000000000002";
